import "./styles.css";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { ReactComponent as ArrowIcon } from "common/assets/svg/leftArrow.svg";
import { useHistory, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import {
  setOfferData,
  requestOfferVality,
  clearOfferValidityData,
  clearSelectedOffer,
} from "common/features/offers/offerActions";
import { getContactlessDineInOrderStatusURL } from "common/utils/route-util";
import LoginRequestPopup from "../../components/prompts/loginRequestPrompt";
import { Fragment } from "react";
import { usePlaceOrder } from "hooks/usePlaceOrder";
import { MAGIL_LOCATION } from "common/constants";
import { AuthContext } from "common/services/auth-service";
import { storeLocationAfterAuth } from "common/features/auth/AuthActions";
import { ReactComponent as MagilLogo } from "common/assets/svg/magilhub_logo.svg";
import { RestaurantDetail } from "common/features/restaurant/restaurantModels";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LoginRequestPrompt from "components/prompts/loginRequestPrompt";
import { dialogOpen } from "common/features/navigation/navigationActions";

const terms = [
  "Offer valid only for registered users.",
  "Offer valid only once per user per restaurant.",
  "Offer valid for limited time only",
];

const OfferCard = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  let paramsData = useParams<any>();
  const [expandList, setexpandList] = useState(false);
  const {
    maxDiscount,
    minOrderAmount,
    offerCode,
    id,
    offerTerms,
    locationId,
    offerRate,
    offerType,
  } = props.data;
  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);
  const isMobile = window.innerWidth <= 500;

  const offers = useSelector((state: RootState) => state.offer);
  const selectedoffersId = offers.offerId;
  const offerValidSuccess = offers.offerValidSuccess;
  const offerValidLoading = offers.offerValidLoading;
  const validityError = offers.offerValidityError;
  const isValidOffer = offers.offerValidSuccess;
  const isValidOfferNot = offers.offerValidFailure;
  const selectedOffer = offers.selectedOffer;
  const AppAuth = useContext(AuthContext);
  //console.log(AppAuth?.userState,AppAuth,"checkingg authvalue")
  const orderDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const orderDetail = useSelector(
    (state: RootState) => state.order.currentOrderDetail
  );

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );

  const [priceValidationError, setpriceValidationError] = useState(false);
  const [isOfferCopied, setIsOfferCopied] = useState<boolean>(false);
  const [
    makeOrder,
    totalItemsubTotal,
    totalOrderPrice,
    totalTaxAndCharges,
    totalItemTaxAmount,
    tipAmount,
    packagingCharge,
  ] = usePlaceOrder();

  const applyOffer = async () => {
    await dispatch(clearSelectedOffer());
    if (locationId === MAGIL_LOCATION) {
      AppAuth?.userState == "signedIn" || AppAuth?.userState == "guestSignedIn"
        ? validateOffer()
        : doAuth();
    } else {
      validateOffer();
    }
  };

  const doAuth = () => {
    dispatch(storeLocationAfterAuth(location.pathname));
    history.push("/signIn");
  };

  const validateOffer = async () => {
    const userId = localStorage.getItem("USER_ID");
    const validityData = {
      customerId: userId ? userId?.toString() : "",
      offerId: id,
      couponCode: offerCode,
      orderId: "",
      locationId: orderDetails.id,
    };

    validityData && await dispatch(requestOfferVality(validityData));
    if (validityData && !isMobile && totalItemsubTotal >= minOrderAmount && selectedOffer ) {
      props.setofferPopup(true);
    }
  };

  const cartRestaurantDetails = useSelector(
    (state: RootState) => state.cart.cartRestaurantDetails
  );

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails && restaurantDetails.media.length > 0) {
        const logoMedia =
          restaurantDetails &&
          restaurantDetails.media.filter(
            (media: any) => media.entityType == type
          )[0];

        return (
          logoMedia.mimeType &&
          process.env.REACT_APP_IMAGE_URL +
            logoMedia.mimeType.split("/")[0] +
            "/" +
            logoMedia.id +
            "." +
            logoMedia.mimeType.split("/")[1]
        );
      } else {
        return "";
      }
    },
    [cartRestaurantDetails, restaurantDetails]
  );

  const isContactlessDineInOrder = useMemo(() => {
    return (
      window.location.pathname.includes("table") &&
      (restaurantDetails.dining == 2 || restaurantDetails.dining == 3)
    );
  }, [restaurantDetails]);

  // const getOfferPercentage = (percentage: number, value: number) => {
  //   return (percentage / 100) * value;
  // };

  // const discountAmount = getOfferPercentage(
  //   props.data.offerRate,
  //   totalItemsubTotal
  // );

  useEffect(() => {
    if (
      !offerValidLoading &&
      offerValidSuccess &&
      selectedoffersId == id &&
      isValidOffer &&
      cartUrl
    ) {
      if (isContactlessDineInOrder) {
        if (orderDetail && orderDetail.totals[0].value >= minOrderAmount) {
          dispatch(setOfferData(props.data));
          dispatch(clearOfferValidityData());
          history.push(
            getContactlessDineInOrderStatusURL(
              paramsData.merchantType,
              paramsData.merchantSlug,
              paramsData.tableId,
              paramsData.orderId
            ),
            { offerdetails: props.data }
          );
        } else {
          setpriceValidationError(true);
        }
      } else {
        if (totalItemsubTotal >= minOrderAmount) {
          dispatch(setOfferData(props.data));
          dispatch(clearOfferValidityData());
          history.push(cartUrl, { offerdetails: props.data });
        } else {
          // history.push(cartUrl);
          setpriceValidationError(true);
        }
      }
    } else if (
      !offerValidLoading &&
      offerValidSuccess &&
      selectedoffersId == id &&
      isValidOffer &&
      !isMobile
    ) {
      if (totalItemsubTotal >= minOrderAmount) {
        dispatch(setOfferData(props.data));
        dispatch(clearOfferValidityData());
        if (AppAuth?.userState === "signedIn" ||
        AppAuth?.userState == "guestSignedIn") {
          props.setloginRequestPopup(false);
        } else {
          props.setloginRequestPopup(true);
        }
        props.onClose(true);
        props.setofferPopup(true);
      } else {
        setpriceValidationError(true);
      }
    }
    return () => {
      dispatch(clearOfferValidityData());
    };
  }, [isValidOffer, offerValidSuccess]);

  const getMerchantOfferTerms = () => {
    let formattedTerms;
    if (offerTerms) {
      formattedTerms = offerTerms.toString().split(".");
      // formattedTerms = formattedTerms.splice(0, formattedTerms.length - 1);
    }
    return formattedTerms;
  };

  const setIsOpen = (set: boolean) => {
    if (set) {
      props.setloginRequestPopup(false);
    }
  };

  // console.log("locationId != MAGIL_LOCATION", locationId != MAGIL_LOCATION)
  // console.log(`getMerchantOfferTerms`, getOfferPercentage(15, 400));
  return (
    <Fragment>
      <div className="offer-card-container" style={isMobile ? {marginLeft: '5%', marginRight: '5%'} : {}}>
        {priceValidationError && (
          <div style={{ marginBottom: "5px" }}>
            <span className="coupon-error-msg">
              {/* Minimum item total amount is Rs. {minOrderAmount} to avail this offer. */}
              Add more Rs. {Math.ceil(minOrderAmount - totalItemsubTotal)} to
              avail this offer
            </span>
          </div>
        )}
        {validityError && selectedoffersId === id && (
          <div style={{ marginBottom: "5px" }}>
            <span className="coupon-error-msg">{validityError}</span>
          </div>
        )}
        <div className="offer-upperContainer">
          <span className="offer-code-container">
            {locationId != MAGIL_LOCATION ? (
              <img
                src={getImageURL("LOGO")}
                className="offer-code-logo"
                alt="logo"
              />
            ) : (
              <MagilLogo className="offer-code-logo" />
            )}
            <span className="offer-code">
              <b> {offerCode}</b>
            </span>
          </span>
          {((props.isShowApplyOffer || isContactlessDineInOrder) && !props.isCopied) ? (
            <>
              {selectedOffer && selectedOffer.id === id ? (
                <span
                  className="applied-text"
                  onClick={() => {
                    // if (AppAuth?.userState === "signedIn") {
                    //   applyOffer();
                    // } else {
                    //   setloginRequestPopup(true);
                    // }
                    dispatch(clearSelectedOffer());
                  }}
                >
                  Applied
                </span>
              ) : (
                <span
                  className="apply-text"
                  onClick={() => {
                    if (
                      AppAuth?.userState === "signedIn" ||
                      AppAuth?.userState == "guestSignedIn"
                    ) {
                      dispatch(dialogOpen(true));
                      applyOffer();
                    } else {
                      props.setloginRequestPopup(true);
                      // console.log('@@@@@@@@@@@@@', setloginRequestPopup )
                    }
                  }}
                  // onClick={() => {
                  //   setloginRequestPopup(true);
                  // }}
                >
                  Apply
                </span>
              )}
            </>
          ) : (
            <CopyToClipboard
              text={offerCode}
              onCopy={() => {
                setIsOfferCopied(true);
                props.setSelectedOfferId(id);
              }}
            >
              <span style={{ color: "#67833E" }}>
                {" "}
                {isOfferCopied && props.selectedOfferId == id
                  ? "Copied"
                  : "Tap to copy"}{" "}
              </span>
            </CopyToClipboard>
          )}
        </div>
        <div className="offer-text-container">
          {offerType === "PERCENT" ? (
            <span className="offer-text">{offerRate}% Off</span>
          ) : (
            <span className="offer-text">
              {restaurantDetails.country === "US" ? "$" : "Rs."} {maxDiscount}{" "}
              Off
            </span>
          )}
        </div>
        <div>
          {offerType === "PERCENT" ? (
            <span className="offer-details-text">
              Use code {offerCode} & get {offerRate}% off on minimum item total
              amount of {restaurantDetails.country === "US" ? "$" : "Rs."}{" "}
              {minOrderAmount} upto{" "}
              {restaurantDetails.country === "US" ? "$" : "Rs."} {maxDiscount}.
            </span>
          ) : (
            <span className="offer-details-text">
              Use code {offerCode} & get{" "}
              {restaurantDetails.country === "US" ? "$" : "Rs."} {maxDiscount}{" "}
              off for minimum item total amount of{" "}
              {restaurantDetails.country === "US" ? "$" : "Rs."}{" "}
              {minOrderAmount}.
            </span>
          )}
        </div>
        <div className="bill-detail" onClick={() => setexpandList(!expandList)}>
          <span>
            <span className="terms-header">Terms & conditions</span>
            <ArrowIcon
              className={
                expandList ? "open-icon open-icon-selected" : "open-icon"
              }
            />
          </span>
        </div>
        {expandList && (
          <React.Fragment>
            {locationId === MAGIL_LOCATION && (
              <div>
                {terms.map((data: string, i: number) => {
                  return <p className="term-text"></p>;
                })}
              </div>
            )}
            {locationId !== MAGIL_LOCATION && (
              <div>
                {getMerchantOfferTerms() &&
                  getMerchantOfferTerms().length > 0 &&
                  getMerchantOfferTerms().map((data: string, i: number) => {
                    return <p className="term-text">{data}</p>;
                  })}
              </div>
            )}
          </React.Fragment>
        )}
        <span></span>
      </div>
    </Fragment>
  );
};

export default OfferCard;
